// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","primaryLight":"#ABEAFF","panel":"_3MJ5QMqBt0j97_G55wFhiz","isOpen":"_2zDjfZmoL97AksiXvMt3xk","main-module":"_317YsSjly1ZAC-trkgHZzc","wrapper":"_2gKDVSfUjbuaF2yjssEMU1","current":"taMi_ef_Hid7MSEXUaynI","extra-modules":"_2p41fT3EbY617QCNEQAcJO","extra-module":"_3ZPJOwYG-1_MvKwYL5w13","number":"_1zjQxk3vyF1oS7SOQs02qm","arrow":"_2p1GR1WdWZtTt9cksG4gvd","bookmark":"_3w-l943wmqhpFC1JlrIpe4","hidden":"_19Uz8BvLl086xJ3kj8akvF","icon":"_2o-StOotD_U3fZX12Jsq8f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModulesPanel/ModulesPanel.mod.css
// module id = 1036
// module chunks = 0